function syncPurchase(form) {
  const option = form.querySelector('select[name="id"]')?.selectedOptions[0];
  if (!option) return;
  const quantity = form.elements.quantity;
  quantity.min = option.dataset.min || '1';
  quantity.step = option.dataset.step || '1';
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  quantity.value = quantity.min;
  const button = form.querySelector('.hx-card-add');
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
}
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest('[data-quantity-change]');
  if (control) {
    const input = control.closest('form').elements.quantity;
    if (Number(control.dataset.quantityChange) > 0) input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('change', {bubbles: true}));
    return;
  }
  const swatch = event.target.closest('.hx-home-swatches a');
  if (swatch) {
    const form = swatch.closest('.hx-product')?.querySelector('.hx-card-purchase');
    const select = form?.querySelector('select[name="id"]');
    if (!select) return;
    select.value = new URL(swatch.href).searchParams.get('variant');
    syncPurchase(form);
  }
});
document.addEventListener('change', event => {
  const input = event.target;
  if (!(input instanceof Element)) return;
  if (input.matches('.hx-card-purchase select[name="id"]')) {
    const form = input.closest('form');
    syncPurchase(form);
    const card = form.closest('product-card,.hx-product');
    const swatch = card?.querySelector(`.hx-home-swatches a[href*="variant=${input.value}"], input[type="radio"][data-variant-id="${input.value}"]`);
    swatch?.click();
    return;
  }
  if (input.matches('input[type="radio"][data-variant-id]')) {
    const form = input.closest('product-card')?.querySelector('.hx-card-purchase');
    const select = form?.querySelector('select[name="id"]');
    if (!select) return;
    select.value = input.dataset.firstAvailableOrFirstVariantId || input.dataset.variantId;
    syncPurchase(form);
  }
});
